import type {
    ControllerProviderType } from "@rosette/royalur_react/src/game/createControllerContext.js";
import {
    createControllerContext,
    useCreateController,
} from "@rosette/royalur_react/src/game/createControllerContext.js";
import { BoardController } from "@rosette/ts/src/business/game/controller/board/BoardController.js";
import type { BoardDirective } from "@rosette/ts/src/business/game/controller/board/BoardDirective.js";


function createBoardControllerContext(): {
    BoardControllerProvider: ControllerProviderType;
    useBoardController: () => BoardController;
    useBoardDirective: () => BoardDirective;
} {
    const useCreateBoardController = () => {
        return useCreateController<BoardDirective, BoardController>(
            () => new BoardController(), [],
        );
    };
    const {
        ControllerProvider, useController, useDirective,
    } = createControllerContext<BoardDirective, BoardController>(useCreateBoardController);

    return {
        BoardControllerProvider: ControllerProvider,
        useBoardController: useController,
        useBoardDirective: useDirective,
    };
}

export const {
    BoardControllerProvider, useBoardController, useBoardDirective,
} = createBoardControllerContext();
